import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IGuestToken } from '@core/interfaces/auth/guest-token.interface';
import { IIamSource } from '@core/interfaces/iam/iam-source.interface';
import { AAGUID } from '@interticket/core';
import { IUserProfile } from '@core/interfaces/user/user-profile.interface';
import { USER_PROFILE, ADMIN_PARTNERS } from '@core/mocks/iam/iam.mock';
import { IAdminPartner } from '@core/interfaces/iam/admin-partner.interface';
import { delay } from 'rxjs/operators';
import { Customer } from '../../models/customer/customer.model';

@Injectable()
export class IamSourceMockService implements IIamSource {

  fetchFeatures(): Observable<string[]> {
    return of(['feature.one', 'feature.two']).pipe(delay(250));
  }

  fetchGuestToken(userId?: AAGUID): Observable<IGuestToken> {
    return of({ accessToken: 'guest_token', userId: userId || 'bb721387-92aa-4224-812c-d0b2b30e5ed1' }).pipe(delay(300));
  }

  getProfile(): Observable<IUserProfile> {
    return of(USER_PROFILE).pipe(delay(300));
  }

  updateCustomerDatas(customer: Customer): Observable<Response> {
    return of(new Response()).pipe(delay(350));
  }

  getAdminPartners(): Observable<IAdminPartner[]> {
    return of(ADMIN_PARTNERS).pipe(delay(250));
  }

}
